import styled from "@emotion/styled";

// global components
import RippleIt from "shared/components/RippleIt";

export const RecentSearchContainer = styled.div`
    font-size: 0.85rem;
    margin-top: 15px;
`;

export const TitleContainer = styled.div`
    display: flex;
    justify-content: space-between;

    & > .title {
        display: flex;
        align-items: center;
        font-weight: 500;
    }
`;

export const ClearButton = styled(RippleIt)`
    display: flex;
    text-decoration: underline;
    height: 30px;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
`;

export const Term = styled(RippleIt)`
    display: flex;
    height: 30px;
    align-items: center;
    padding-left: 5px;
    margin-left: -5px;
    cursor: pointer;
`;
